import { render, staticRenderFns } from "./OrganismContactColumns.vue?vue&type=template&id=1afc803c&"
import script from "./OrganismContactColumns.vue?vue&type=script&lang=js&"
export * from "./OrganismContactColumns.vue?vue&type=script&lang=js&"
import style0 from "./OrganismContactColumns.vue?vue&type=style&index=0&id=1afc803c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
